import React from "react";

// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

// Table Params
import {COLUMNS, LOCALIZATION, OPTIONS} from "./Params/LogBackendErrorParams";
import {tableIcons} from "../../ui-components/TableIcons";
import TableStyle from "../../ui-components/TableStyle";

function LogBackendErrorTable({data}) {


  return (
    <TableStyle>
      <MaterialTable
        icons={tableIcons}
        columns={COLUMNS}
        data={data.map((value, index) => ({...value, id: index}))}
        options={OPTIONS}
        title={"Backend"}
        localization={LOCALIZATION}
      />
    </TableStyle>
  );
}

export default React.memo(LogBackendErrorTable, (props, nextProps) => {
  // Render component only when users change
  return _.isEqual(props.data, nextProps.data);
});
